function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from 'react';
import Ribbon from '@shared/components/ribbon';
import NewBadge from '@shared/images/NewBadge.svg';
const maxRibbonItems = 5;
export const RecommendationsRibbon = ({ recommendedItems = [], title, ribbonKey, selectedCountry, selectedLocale, tileType: TileType })=>{
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: recommendedItems.length >= maxRibbonItems && /*#__PURE__*/ _jsx(Ribbon, {
            title: title,
            imgSource: NewBadge,
            children: recommendedItems.map((item, index)=>{
                return /*#__PURE__*/ _createElement(TileType, _object_spread_props(_object_spread({}, item), {
                    item: item,
                    key: item.entityId,
                    customCSSClass: 'tile' + index,
                    tileIndex: index,
                    totalTiles: recommendedItems.length,
                    selectedLocale: selectedLocale,
                    countryContext: selectedCountry,
                    ribbonKey: `Recommended_${ribbonKey}`
                }));
            })
        })
    });
};
